import { useState, useContext, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { IconButton, TextField, Typography, Select, MenuItem } from '@mui/material';
import Grid from '@mui/material/Grid2';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import config from '../../config.js';
import MovimentsListEdit from '../common/MovimentsListEdit.js';
import AppContext from '../AppContext'; 
import { listAnysWithAll } from '../../functions/common-lists.js';
import { formatEuro } from '../../functions/formatNumber.js';

const CercadorMovimentsGlobal = () => {
  const { ctxUser, ctxApp } = useContext(AppContext);
  const [movements, setMovements] = useState({list:[], total:0});
  const [searchText, setSearchText] = useState(ctxApp?.textSearch || '');
  const [searchAnio, setSearchAnio] = useState(ctxApp?.anioSearch || 'All');
  const [isSearching, setIsSearching] = useState(false);
  const searchInputRef = useRef(null); // Ref para el campo de texto
  
  const { userapp: paramUserapp } = useParams();
  const userapp = paramUserapp;
  
  const jwtToken = ctxUser?.fdvToken ? ctxUser.fdvToken.jwtToken : '';
  
  // Función para obtener la lista completa de movimientos
  const closeSearch = () => {
    setMovements({list:[], total:0});
    setSearchText('');
    setSearchAnio('All');
    ctxApp.textSearch = '';
    searchInputRef.current?.focus();
    setIsSearching(false);
  };

  // Función para buscar movimientos
  const searchMovements = async () => {
    if (!searchText?.trim()) return;

    const text = searchText.trim();
    let anio = searchAnio;
    if(anio === 'All') {
      anio = undefined;
    }

    try {
      const response = await axios.get(`${config.apiBaseUrl}/v1/concmovs/searchtext/${userapp}`, {
        headers: { Authorization: `${jwtToken}`},
        params: { 
          text,
          anio
        }
      });

      let list = response.data || [];
      var sum = list.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.importe;
      },0);

      const myMovements = {
        list,
        total: sum
      };
      setMovements(myMovements);

      ctxApp.textSearch = text;
      setIsSearching(true);
    } catch (error) {
      console.error('Error al buscar movimientos:', error);
    }
  };

  // Manejador del evento 'Enter' en el campo de texto
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      searchMovements();
    }
    else if (event.key === 'Escape') {
      closeSearch();
    }
  };  

  const handleAnio = (event) => {
    let anio = event.target.value;
    setSearchAnio(anio);
    //searchMovements();
  }; 

  useEffect(() => {
    searchMovements();
    // eslint-disable-next-line
  }, [searchAnio]);  

  return (
    <>
      <Grid container direction="column" spacing={2}>
        {/* Barra de búsqueda */}
        <Grid item>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={10}>
              <TextField
                fullWidth
                variant="outlined"
                placeholder="Cercar moviments"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyDown={ handleKeyDown }
                inputRef={ searchInputRef }
              />
            </Grid>
            <Select
              value={searchAnio}
              label="Any"
              onChange={handleAnio}
            >
              {listAnysWithAll().map((year) => (
                <MenuItem key={year} value={year}>
                  {year}
                </MenuItem>
              ))}
            </Select>            
            <Grid item>
              <IconButton color="primary" onClick={searchMovements}>
                <SearchIcon />
              </IconButton>
            </Grid>
            {isSearching && (
              <Grid item>
                <IconButton color="secondary" onClick={closeSearch}>
                  <CloseIcon />
                </IconButton>
              </Grid>
            )}

            <Typography>
              Num. Moviments: {movements.list?.length}
            </Typography>  
            <Typography>
              Import total: {formatEuro(movements.total)}
            </Typography>                        
          </Grid>
        </Grid>
      </Grid>
      <MovimentsListEdit moviments={movements.list} showYear={true} onEditComplete={searchMovements}/>
    </>
  );
};

export default CercadorMovimentsGlobal;
